import { 
  Box, Typography, Button, IconButton 
} from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../../context/language/language';
import { TitleModal } from '../../../MyAccount/common';
import { choiceSelectionModalSize } from '../modalSize';
import { getImageURL } from '../../../../utils/getImageURL';
import useDeliveryControlFlow from '../../../common/hook/useDeliveryControlFlow';
import { useReorder } from '../../../common/hook/useReorder';
import { ModalInfo } from '../../../common';

const Icon = getImageURL('/icon/clear-cart.svg');
const closeIcon = getImageURL('/icon/cross-btn.svg');

const useStyle = makeStyles((theme, disabled) => ({
  root: {
    [theme.breakpoints.up('md')]: {
      width: choiceSelectionModalSize.width,
      padding: 24,
      boxSizing: 'border-box',
    },
  },
  customTitleModal: {
    ...theme.custom.fonts.header3,
  },
  textDesc: {
    whiteSpace: 'pre-line'
  },
  btnSubmit: {
    width: '100%',
    backgroundColor: theme.custom.colors.green600,
    color: disabled ? theme.custom.colors.grey500 : theme.custom.colors.white,
    height: 44,
    textTransform: 'none',
    ...theme.custom.radius.m,
    ...theme.custom.fonts.header6,

    '&:hover': {
      backgroundColor: theme.custom.colors.green400,
    },
  },
  btnCancel: {
    width: '100%',
    marginRight: 8,
    backgroundColor: theme.custom.colors.grey75,
    height: 44,
    textTransform: 'none',
    ...theme.custom.radius.m,
    ...theme.custom.fonts.header6,
  },
  icon: {
    width: 64,
    height: 64,
  },
  iconButton: {
    width: 44,
    height: 44,
  }
}));

function ReorderDialog() {
  const word = useLanguage();
  const classes = useStyle();
  const reorder = useReorder();
  const deliveryControl = useDeliveryControlFlow();
  const NewLineText = (text) => (_.isString(text) ? text?.replace(/\\n/g, '<br/>') : text);
  

  return (
    <ModalInfo
      isOpen={deliveryControl.showModal}
      title={word('Reorder.Warning.Title')}
      description={(<div className={classes.textDesc} dangerouslySetInnerHTML={{ __html: NewLineText(word('Reorder.Warning.Description.Web')) }} />)}
      type="info"
      showCancel
      showIcon
      showHeader
      cancelText={word('Reorder.Warning.Merge')}
      labelText={word('Reorder.Warning.New')}
      onClose={reorder.mergeCartReorder}
      onConfirm={reorder.newCartReorder}
    />
  );
}

export default ReorderDialog;
